import SettingBase from '../settings/util/SettingBase'

class LogController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.$state = $state
    this.id = "log"
    this.acl = {}
    this.hasACL = {}

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-' + this.id]) {
      this.hasACL[this.acl['setting-' + this.id][key]] = true;
    }
  }
}

export default LogController;


// WEBPACK FOOTER //
// ./client/app/components/log/log.controller.js